<template>
  <div class="bill-details" ref="container">
    <div class="nav acea-row">
      <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
        全部
      </div>
      <div class="item" :class="types == index ? 'on' : ''" @click="changeTypes(index)" v-for="(item, index) in moneyType" :key="index">
        {{item}}
      </div>
    </div>
    <div class="sign-record">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="data">{{ item.time }}</div>
          <div class="listn" v-for="(val, key) in item.list" :key="key">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <div class="name line1">{{ val.category_name }}（{{ val.title }}）</div>
              </div>
              <div style="width:100%;">
                <div class="name line1"></div>
                <div style="color:#999;">{{ val.mark }}</div>
                <div style="width:100%;">
                  <div style="float:left;width:50%;margin-top:0.2rem;">{{ val.add_time }}</div>
                  <div style="float:right;width:50%;text-align:right;" class="num" :class="val.number < 0 ? 'font-color-red-l' : ''">
                    {{ val.number < 0 ? "" : "+" }}{{ val.number }}
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .font-color-red-l {
    color:red !important;
  }
</style>
<script>
    import { getCommissionInfo } from "../../api/user";
    import Loading from "@components/Loading";
    export default {
        name: "UserBill",
        components: {
            Loading
        },
        props: {},
        data: function() {
            return {
                types: "",
                where: {
                    page: 1,
                    limit: 5
                },
                moneyType:[],
                list: [],
                loaded: false,
                loading: false
            };
        },
        watch: {
            "$route.params.types": function(newVal) {
                let that = this;
                if (newVal != undefined) {
                    that.types = newVal;
                    that.list = [];
                    that.where.page = 1;
                    that.loaded = false;
                    that.loading = false;
                    that.getIndex();
                }
            },
            types: function() {
                this.getIndex();
            }
        },
        mounted: function() {
            let that = this;
            that.types = that.$route.params.types;
            that.getIndex();
            that.$scroll(that.$refs.container, () => {
            !that.loading && that.getIndex();
        });
        },
        methods: {
            code: function() {
                this.sendCode();
            },
            changeTypes: function(val) {
                if (val != this.types) {
                    this.types = val;
                    this.list = [];
                    this.where.page = 1;
                    this.loaded = false;
                    this.loading = false;
                }
            },
            getIndex: function() {
                let that = this;
                if (that.loaded == true || that.loading == true) return;
                that.loading = true;
                getCommissionInfo(that.where, that.types).then(
                    res => {
                        that.loading = false;
                        that.moneyType = res.data.moneyType;
                        that.loaded = res.data.list.length < that.where.limit;
                        that.where.page = that.where.page + 1;
                        that.list.push.apply(that.list, res.data.list);
                    },
                    error => {
                        that.$dialog.message(error.msg);
                    }
            );
            }
        }
    };
</script>
